import ProcessFlowStep from "~/models/processFlows/processFlowStep"
import {ProcessFlowStepType} from "~/enums/processFlowStepType"
import {IAnyProcessFlowCallToAction, IRedirectStep} from '~/interfaces/processFlowInterfaces'
import ProcessFlow from '~/models/processFlows/processFlow'
import ProcessFlowCallToActionContainer from '~/mixins/processFlowCallToActionContainer'

export class ProcessFlowRedirectStep extends ProcessFlowCallToActionContainer(ProcessFlowStep) implements IRedirectStep {
  step_type: ProcessFlowStepType.Redirect
  new_tab: boolean
  call_to_action: IAnyProcessFlowCallToAction = null

  constructor(parent: ProcessFlow, options?) {
    super(parent, options)
    this.defineProperty<this>('new_tab', true)
  }

  get defaultTitle(): 'Redirect' {
    return 'Redirect'
  }
}